import { RouteRecordRaw } from 'vue-router';
import Game from "../views/game/Game.vue";
import GameTask from "../views/game-task/GameTask.vue";
import Category from "../views/category/Category.vue";
import ApiKey from "../views/apikey/ApiKey.vue";
import Recommend from "../views/recommend/Recommend.vue";
import Maintenance from "../views/maintenance/Maintenance.vue";
import Analytics from "../views/analytics/Analytics.vue";
import ChannelRule from "../views/analytics/ChannelRule.vue";
import FeishuBot from "../views/analytics/FeishuBot.vue";
import SkyMobiStats from "../views/analytics/SkyMobiStats.vue";
import PassthroughPage from "../views/passthrough/PassthroughPage.vue";
import PassthroughGame from "../views/passthrough/PassthroughGame.vue";
import PassthroughH5Config from "../views/passthrough/PassthroughH5Config.vue";
import PassthroughProductH5Config from "../views/passthrough/PassthroughProductH5Config.vue";
import Article from "../views/article/Article.vue";
import Collection from "../views/collection/Collection.vue";
import Banner from "../views/banner/Banner.vue";
import SkyMobiConfig from "../views/config/SkyMobiConfig.vue";
import SkyMobiAppConfigs from "../views/config/SkyMobiAppConfigs.vue";

export const routes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: '/game' // 默认重定向到 '/game'
    },
    {
        name: 'Game',
        path: '/game',
        component: Game,
    }, {
        name: 'GameTask',
        path: '/game-task',
        component: GameTask,
    }, {
        name: 'Category',
        path: '/category',
        component: Category,
    }, {
        name: 'ApiKey',
        path: '/apikey',
        component: ApiKey,
    },     {
        name: 'Recommend',
        path: '/recommend',
        component: Recommend,
    }, {
        name: 'Maintenance',
        path: '/maintenance',
        component: Maintenance,
    }, {
        name: 'Analytics',
        path: '/analytics',
        component: Analytics,
    }, {
        name: 'ChannelRule',
        path: '/analytics/channel-rule',
        component: ChannelRule,
    }, {
        name: 'FeishuBot',
        path: '/analytics/feishu-bot',
        component: FeishuBot,
    }, {
        name: 'SkyMobiStats',
        path: '/analytics/sky-mobi-stats',
        component: SkyMobiStats,
    }, {
        name: 'PassthroughPage',
        path: '/passthrough/page',
        component: PassthroughPage,
    }, {
        name: 'PassthroughGame',
        path: '/passthrough/game',
        component: PassthroughGame,
    }, {
        name: 'PassthroughH5Config',
        path: '/passthrough/h5config',
        component: PassthroughH5Config,
    }, {
        name: 'PassthroughProductH5Config',
        path: '/passthrough/product-h5config',
        component: PassthroughProductH5Config,
    }, {
        name: 'Article',
        path: '/article',
        component: Article,
    }, {
        name: 'Collection',
        path: '/collection',
        component: Collection,
    },     {
        name: 'Banner',
        path: '/banner',
        component: Banner,
    },     {
        name: 'SkyMobiConfig',
        path: '/config/sky-mobi',
        component: SkyMobiConfig,
    }, {
        name: 'SkyMobiAppConfigs',
        path: '/config/sky-mobi/app/:packageName',
        component: SkyMobiAppConfigs,
    },
]